// tslint:disable:max-line-length
import { Text, Colors, Media, Spacing } from '@doordash/design-language'

import styled from 'styled-components'
import {
  COLOR_PINK_BGC,
  HEADER_SECTION as Style,
} from '../../../landing/constants'

import { AWS_BASE, CLOUDFLARE_DEFAULT_BASE } from '../../../../../constants'

const heroDesktopURL = `${CLOUDFLARE_DEFAULT_BASE}/${AWS_BASE}/img/dasher/landingpage_hero_desktop_nowave.jpg`
const heroMobileURL = `${CLOUDFLARE_DEFAULT_BASE}/${AWS_BASE}/img/dasher/landingpage_hero_mobile.png`

type HeaderProps = {
  experiment: boolean
}

export const TermsButton = styled.button`
  padding: 0;
  background: inherit;
  cursor: pointer;
  border: none;
  margin-top: ${Spacing.Large}px;
  color: ${Colors.SystemWhite};
  text-decoration: underline;
  font-weight: ${Style.TERMS_BUTTON.FONT_WEIGHT};
`

export const Root = styled.section`
  min-height: ${Style.ROOT.MIN_HEIGHT};
  background: black;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 3rem 0 4rem;
  position: relative;
  overflow: hidden;

  @media (max-width: 960px) {
    padding: 0 1rem;
  }

  @media (max-width: 480px) {
    min-height: 220px;
  }
`

export const TextContainer = styled<HeaderProps, 'div'>('div')`
  z-index: 1;
  padding-bottom: ${Style.TEXT_CONTAINER.PADDING_BOTTOM};
  text-align: center;
  text-shadow: 3px 3px 8px ${Colors.SystemGrey100};

  ${Media.Mobile`
    margin-top: ${Spacing.XLarge}px;
    text-shadow: unset;
    padding-bottom: 0px;
    ${(props: HeaderProps) => props.experiment && `text-shadow: unset;`}
  `}
`

export const TitleText = styled(Text)`
  color: ${Colors.SystemWhite};
  font-weight: ${Style.TITLE_TEXT.FONT_WEIGHT};
  font-size: ${Text.Sizes.S32}px;
  max-width: ${Style.TITLE_TEXT.MAX_WIDTH};
  line-height: ${Style.TITLE_TEXT.LINE_HEIGHT};

  ${Media.Mobile`
    ${(props: HeaderProps) =>
      props.experiment &&
      `
        font-size: ${Style.TITLE_TEXT.MOBILE_FONT_SIZE};
        color: ${Colors.TextSecondary};
      `}
  `}
`

export const SubtitleText = styled(Text)`
  color: ${Colors.SystemWhite};
  margin: 0 auto;
  padding-top: ${Spacing.Large}px;
  line-height: ${Spacing.XLarge}px;
  font-weight: bold;
  font-size: ${Style.SUBTITLE_TEXT.FONT_SIZE};
  max-width: ${Style.SUBTITLE_TEXT.MAX_WIDTH};

  ${Media.Mobile`
    display: none;
  `}
`

export const HeroContainer = styled<HeaderProps, 'div'>('div')`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  background: url(${heroDesktopURL}) no-repeat;
  background-position: center top;
  background-size: cover;
  background-color: ${Colors.SystemWhite};
  &:after {
    content: '';
    height: 100%;
    width: 100%;
    z-index: 1;
    display: block;
  }

  ${Media.Mobile`
    ${(props: HeaderProps) =>
      props.experiment
        ? `background: ${Colors.SystemRed5};`
        : `background: linear-gradient(-180deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0) 100%), url(${heroMobileURL}) no-repeat center center;`}
    background-color: ${COLOR_PINK_BGC};
    background-size: cover;
    background-position-y: 60px;
  `}
`

type ChildrenProps = {
  alignChildren: 'top' | 'center' | 'bottom'
}

export const ChildrenWrapper = styled.div`
  margin: ${Spacing.Large}px 0 ${Spacing.Large}px 0;
  z-index: 1;
  ${(props: ChildrenProps) => {
    return props.alignChildren === 'bottom' ? 'margin-bottom: 0.5rem' : null
  }};

  align-self: ${(props: ChildrenProps) => {
    if (props.alignChildren === 'top') {
      return 'flex-start'
    }
    if (props.alignChildren === 'center') {
      return 'center'
    }
    return 'flex-end'
  }};
`

export const H1 = styled.h1`
  margin: 0;
`

export const H2 = styled.h2`
  margin: 0;
`
